import { UsStateCodes } from '../../../../../../constants/us-state-codes';

/**
 * State population weights based on approximate 2020 US Census data.
 * These weights represent each state's proportion of the total US population.
 * Used for calculating weighted average shipping zones and metrics.
 */
export const STATE_POPULATION_WEIGHTS = new Map([
  [UsStateCodes.Alabama, 0.0149],
  [UsStateCodes.Alaska, 0.0022],
  [UsStateCodes.Arizona, 0.0221],
  [UsStateCodes.Arkansas, 0.0092],
  [UsStateCodes.California, 0.1192],
  [UsStateCodes.Colorado, 0.0175],
  [UsStateCodes.Connecticut, 0.0109],
  [UsStateCodes.Delaware, 0.003],
  [UsStateCodes.Florida, 0.0651],
  [UsStateCodes.Georgia, 0.0323],
  [UsStateCodes.Hawaii, 0.0043],
  [UsStateCodes.Idaho, 0.0054],
  [UsStateCodes.Illinois, 0.0385],
  [UsStateCodes.Indiana, 0.0204],
  [UsStateCodes.Iowa, 0.0096],
  [UsStateCodes.Kansas, 0.0088],
  [UsStateCodes.Kentucky, 0.0136],
  [UsStateCodes.Louisiana, 0.0141],
  [UsStateCodes.Maine, 0.0041],
  [UsStateCodes.Maryland, 0.0184],
  [UsStateCodes.Massachusetts, 0.021],
  [UsStateCodes.Michigan, 0.0304],
  [UsStateCodes.Minnesota, 0.0171],
  [UsStateCodes.Mississippi, 0.009],
  [UsStateCodes.Missouri, 0.0187],
  [UsStateCodes.Montana, 0.0033],
  [UsStateCodes.Nebraska, 0.0059],
  [UsStateCodes.Nevada, 0.0094],
  [UsStateCodes.NewHampshire, 0.0041],
  [UsStateCodes.NewJersey, 0.027],
  [UsStateCodes.NewMexico, 0.0064],
  [UsStateCodes.NewYork, 0.0592],
  [UsStateCodes.NorthCarolina, 0.0318],
  [UsStateCodes.NorthDakota, 0.0023],
  [UsStateCodes.Ohio, 0.0355],
  [UsStateCodes.Oklahoma, 0.012],
  [UsStateCodes.Oregon, 0.0128],
  [UsStateCodes.Pennsylvania, 0.0389],
  [UsStateCodes.RhodeIsland, 0.0032],
  [UsStateCodes.SouthCarolina, 0.0156],
  [UsStateCodes.SouthDakota, 0.0027],
  [UsStateCodes.Tennessee, 0.0207],
  [UsStateCodes.Texas, 0.0879],
  [UsStateCodes.Utah, 0.0097],
  [UsStateCodes.Vermont, 0.0019],
  [UsStateCodes.Virginia, 0.026],
  [UsStateCodes.Washington, 0.0232],
  [UsStateCodes.WestVirginia, 0.0055],
  [UsStateCodes.Wisconsin, 0.0177],
  [UsStateCodes.Wyoming, 0.0018],
  [UsStateCodes.DistrictOfColumbia, 0.0022],
]);
